import React from 'react';

interface CardProps {
  accent?: boolean;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ accent = false, className = '', children, onClick }) => (
  <div
    onClick={onClick}
    className={`bg-raised border border-line rounded-sm ${
      accent ? 'border-l-[3px] border-l-accent' : ''
    } ${onClick ? 'cursor-pointer transition-colors hover:border-line-strong' : ''} ${className}`}
  >
    {children}
  </div>
);
